import styles from './BlurredCell.scss';
import React from 'react';

const blurredCell = (content: string, blurDashboard: boolean) => <div className={blurDashboard ? styles.blurred : undefined}>{content}</div>;

export default blurredCell;
